import React from "react";
import { Box } from "@mui/material";
import { useCreditCardForwardForm } from "hooks/useCreditCardForwardForm";
import CreditCardFormSkeleton from "components/Skeleton/CreditCardFormSkeleton";

const CreditCardForwardForm = ({
 handleCardError,
 setTokenForward,
}) => {
 const {
  payWithCreditCard,
  CREDIT_CARD,
  ref,
 } = useCreditCardForwardForm(handleCardError, setTokenForward);
  return (
    <>
      <Box sx={{ position: "relative", height: "auto", mt: 2 }}>
        <Box
          sx={{ mt: 2, mb: 2, display: payWithCreditCard === CREDIT_CARD ? 'block' : 'none' }}
          ref={ref}
          id="card-form">
        </Box>
      </Box>
    </>
  );
};

export default CreditCardForwardForm;
